<form #contactForm="ngForm" class="mat-surface-container h-100 d-flex flex-column py-3 px-4" (submit)="submit()">
  @if (colorMode.currentMode() === 'dark') {
    <img
      src="/assets/img/compass-logo-dark.png"
      class="align-self-center"
      alt="Compass logo"
      width="145"
      height="145"
    />
  } @else {
    <img src="/assets/img/compass-logo.png" class="align-self-center" alt="Compass logo" width="145" height="145" />
  }
  <div class="mat-headline-small text-center">Help Us Improve</div>
  <p class="fw-semibold balance">Please rate your overall experience using our website.</p>
  <contact-rating class="align-self-center mb-3" [(ngModel)]="contactFormData.rating" name="rating" />
  <p class="balance mb-4">What type of feedback would you like to give?</p>
  <mat-form-field [hideRequiredMarker]="true">
    <mat-label>Feedback type</mat-label>
    <mat-select name="subject" [(ngModel)]="contactFormData.subject" required>
      <mat-option value="General website feedback">General website feedback</mat-option>
      <mat-option value="Report a problem">Report a problem</mat-option>
    </mat-select>
  </mat-form-field>
  @if (contactFormData.subject) {
    @if (contactFormData.subject === 'General website feedback') {
      <p>Tell us about your experience with the website.</p>
      <ul>
        <li>What are we doing well?</li>
        <li>What can we improve?</li>
      </ul>
    }
    <mat-form-field [hideRequiredMarker]="true">
      <mat-label>Your {{ contactFormData.subject === 'Report a problem' ? 'problem' : 'feedback' }}</mat-label>
      <textarea matInput name="message" [(ngModel)]="contactFormData.message" rows="5" required></textarea>
    </mat-form-field>
  }
  <div class="d-flex gap-2">
    <button type="submit" mat-flat-button class="flex-grow-1" [disabled]="contactForm.invalid">Submit</button>
    <button type="button" mat-stroked-button class="flex-grow-1" (click)="contactClose.emit()">Cancel</button>
  </div>
</form>
